import script from "./BowlerResultsSummary.vue?vue&type=script&lang=ts&setup=true"
export * from "./BowlerResultsSummary.vue?vue&type=script&lang=ts&setup=true"

import "./BowlerResultsSummary.vue?vue&type=style&index=0&id=01c5357c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01c5357c"]])

export default __exports__